import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { GeneratedContentMakeLongerInput, GeneratedContentMakeLongerPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = GeneratedContentMakeLongerInput;
type TData = GeneratedContentMakeLongerPayload;

export const useContentGenerationExpand = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation generatedContentMakeLonger($input: GeneratedContentMakeLongerInput!) {
      generatedContentMakeLonger(input: $input) {
        success
        errors
        errorCode
        text
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
